export default "__VITE_ASSET__CJrbD0VL__"